<script setup lang="ts">
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

defineProps<{
  total: any
  current: number
  newStyle?: boolean
}>()

const emit = defineEmits(['pageChange'])

/**
 *
 * @param page number
 */
function changePage(page: number) {
  emit('pageChange', page)
}

/**
 *
 * @param page number
 */
function prev(page: number) {
  emit('pageChange', page - 1)
}

/**
 *
 * @param page number
 */
function next(page: number) {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  })
  emit('pageChange', page + 1)
}
</script>

<template>
  <div>
    <nav
      class="flex items-center justify-center"
      :class="newStyle ? 'mb-2 mt-5' : 'my-5 space-x-2'"
    >
      <a
        class="inline-flex items-center gap-2 rounded-md hover:text-blue-600"
        :class="[
          current == 1
            ? 'pointer-events-none text-gray-400 dark:text-gray-700'
            : 'cursor-pointer text-gray-700 dark:text-gray-400',
          newStyle ? 'mr-1 mt-0.5 p-1' : 'p-2.5'
        ]"
        @click="prev(current)"
      >
        <FontAwesomeIcon
          icon="fa-angle-left"
          :class="
            newStyle
              ? 'h-3 w-3'
              : 'h-6 w-5 rounded-md bg-neutral-200 px-1.5 py-1 dark:bg-neutral-800'
          "
          aria-hidden="true"
        ></FontAwesomeIcon>
        <span class="sr-only">Previous</span>
      </a>
      <div>
        <a
          class="inline-block cursor-pointer rounded-md border-2 p-0.5 text-center"
          :class="
            newStyle
              ? 'text-mid background-primary mx-1 items-center border-none px-3 text-base '
              : `mx-3 h-8 w-8 font-medium ${current === 1 ? 'border-red-400' : 'border-slate-500'}`
          "
          aria-current="page"
          @click="newStyle ? null : changePage(1)"
        >
          {{ newStyle ? current : 1 }}
        </a>
        <span
          class="inline-block h-10 w-10 rounded-full p-2.5 text-center text-sm font-medium"
          v-if="!newStyle && current > 4"
          >...</span
        >
        <span
          class="text-mid inline-block rounded-full px-1 py-2.5 text-center text-base"
          v-if="newStyle"
          >of</span
        >

        <a
          v-for="(page, index) in total"
          :key="index"
          class="mx-3 inline-block h-8 w-8 cursor-pointer rounded-md border-2 p-0.5 text-center font-medium"
          v-show="
            !newStyle && page != total && page != 1 && page - current < 3 && current - page < 3
          "
          :class="current === page ? 'border-red-400' : 'border-slate-500'"
          aria-current="page"
          @click="changePage(page)"
        >
          {{ page }}
        </a>

        <span
          class="inline-block h-10 w-10 rounded-full p-2.5 text-center text-sm font-medium"
          v-if="!newStyle && total - current > 3"
          >...</span
        >
        <a
          v-if="newStyle ? total >= 0 : total > 1"
          class="mt-auto inline-block cursor-pointer rounded-md border-2 p-0.5 text-center"
          :class="
            newStyle
              ? 'text-mid mx-1 border-none text-base '
              : `mx-3 h-8  w-8 font-medium ${
                  current === total ? 'border-red-400' : 'border-slate-500'
                }`
          "
          aria-current="page"
          @click="newStyle ? null : changePage(total)"
        >
          {{ total }}
        </a>
      </div>

      <a
        class="inline-flex items-center gap-2 rounded-md hover:text-blue-600"
        :class="[
          current == total
            ? 'pointer-events-none text-gray-400 dark:text-gray-700'
            : 'cursor-pointer text-gray-700 dark:text-gray-400',
          newStyle ? 'ml-1' : 'p-2.5'
        ]"
        @click="next(current)"
      >
        <span class="sr-only">Next</span>
        <FontAwesomeIcon
          icon="fa-angle-right"
          :class="
            newStyle
              ? 'h-3 w-3'
              : 'h-6 w-5 rounded-md bg-neutral-200 px-1.5 py-1 dark:bg-neutral-800'
          "
          aria-hidden="true"
        ></FontAwesomeIcon>
      </a>
    </nav>
  </div>
</template>
